<div class="alert alert-error" *ngIf="requestService.error">{{ requestService.error }}</div>

<fl-stepper #stepper="fl-stepper" *ngIf="!requestService.success">
  <!-- STEP 1: Add Form/Docs -->
  <fl-stepper-section label="Select Forms">
    <div class="fl-stepper-subsection">
      <h1>Select Forms</h1>
      <p>
        These are forms or documents that require user input. You can rearrange them into a specific order.
      </p>
      <ng-container *ngIf="formsToShare.length > 0; else elseNoForms">
        <div class="table">
          <table class="dataset" cdkDropList (cdkDropListDropped)="onDropObject($event, formsToShare)">
            <thead>
              <tr>
                <th class="column-drag-handle"></th>
                <th colspan="2">Form</th>
                <th>Applies To</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let form of formsToShare" cdkDrag>
                <td class="column-drag-handle">
                  <div class="--drag-handle" cdkDragHandle>
                    <i class="material-icons">drag_handle</i>
                  </div>
                </td>
                <td class="column-thumbnail">
                  <ng-container *ngIf="form.document; else elseNoDocument">
                    <img
                      [src]="form.document.thumbnail"
                      class="thumbnail"
                      *ngIf="form.document.thumbnail"
                    />
                  </ng-container>
                  <ng-template #elseNoDocument>
                    <div class="thumbnail">
                      <i class="material-icons">ballot</i>
                    </div>
                  </ng-template>
                </td>
                <td>
                  <a
                    class="clip-string-2"
                    title="{{ form.title }}"
                    target="_blank"
                    [routerLink]="
                      form.global ? ['/builder/form', form.id, 'preview'] : ['/builder/form', form.id]
                    "
                    style="text-decoration: none"
                  >
                    <strong>
                      <i class="material-icons flow-global" style="font-size: 17px" *ngIf="form.global"
                        >lock</i
                      >
                      {{ form.title }}
                    </strong>
                  </a>

                  <div style="margin-top: 3px">
                    <ng-container *ngIf="form.display_type === 'single'"> Single page form </ng-container>

                    <ng-container *ngIf="form.display_type === 'tabbed'"> Tabbed form </ng-container>

                    <ng-container *ngIf="form.display_type === 'wizard'"> Multipage wizard </ng-container>

                    <span class="label primary-light" *ngIf="form.internal" style="margin: 0 0 0 5px">
                      Internal
                    </span>

                    <span class="label primary" *ngIf="form.global" style="margin: 0 0 0 5px">
                      Flow Library
                    </span>

                    <span
                      *ngIf="form.vehicle && form.vehicle.is_template"
                      class="label primary"
                      style="margin: 0 0 0 5px"
                    >
                      Template Form
                    </span>
                  </div>
                </td>
                <td>
                  <div class="flex-container">
                    <div class="iconic-status flex-container vertical-center">
                      <i class="material-icons">
                        {{ documentService.ASSIGNABLE_ICONS[form.assignable_to] }}
                      </i>
                      {{ documentService.ASSIGNABLE_TITLES[form.assignable_to] }}
                    </div>
                    <ng-container
                      *ngIf="
                        ASSIGNABLE_SELECTABLES.includes(form.assignable_to) &&
                        (entities.length > 0 || vehicles.length > 0)
                      "
                    >
                      <mat-form-field
                        appearance="outline"
                        class="flex-cell"
                        floatLabel="always"
                      >
                        <mat-label>Select {{ form.assignable_to }}</mat-label>
                        <mat-select
                          [(ngModel)]="form.assignable_id"
                          name="form_assignable_id"
                          [required]="true"
                        >
                          <ng-container *ngIf="form.assignable_to === 'vehicle'">
                            <mat-option *ngFor="let vehicle of vehicles" [value]="vehicle.id">
                              {{ vehicle.name }}
                            </mat-option>
                          </ng-container>
                          <ng-container *ngIf="form.assignable_to === 'entity'">
                            <mat-option *ngFor="let entity of entities" [value]="entity.id">
                              {{ entity.legal_name }}
                            </mat-option>
                          </ng-container>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                  </div>
                </td>
                <td style="width: 42px">
                  <i class="material-icons show-on-hover" (click)="removeForm(form.id)">close</i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <button class="add-forms" (click)="openDocumentSearchDialog('forms')">
          <i class="material-icons">description</i>
          Add Additional Forms
        </button>
      </ng-container>

      <!-- First time adding forms -->
      <ng-template #elseNoForms>
        <button class="add-forms" (click)="openDocumentSearchDialog('forms')">
          <i class="material-icons">description</i>
          Add Forms
        </button>
      </ng-template>
    </div>

    <div class="fl-stepper-footer flex-container">
      <!-- Empty element is here to align button to the right -->
      <div></div>

      <button
        class="next"
        [disabled]="!hasValidFormsOrDocs()"
        (click)="stepperNavigateNext()"
      >
        Next
      </button>
    </div>
  </fl-stepper-section>

  <!-- STEP 2: Add Recipients -->
  <fl-stepper-section label="Add Recipients" [validationMethod]="hasValidFormsOrDocs.bind(this)">
    <div>
      <ng-container *ngIf="scope === SCOPE_VEHICLE">
        <h1>Add Recipients</h1>
        <div
          class="table table-investment-recipients"
          [class.has-counter-signers]="true"
          *ngIf="vehicleInvestmentRecipients.length > 0; else elseNoVehicleRecipients"
        >
          <table mat-table class="dataset" [dataSource]="vehicleInvestmentRecipients">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? masterToggle() : null"
                  [checked]="vehicleInvestmentRecipientsSelection.hasValue() && isAllSelected()"
                  [indeterminate]="vehicleInvestmentRecipientsSelection.hasValue() && !isAllSelected()"
                >
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? vehicleInvestmentRecipientsSelection.toggle(row) : null"
                  [checked]="vehicleInvestmentRecipientsSelection.isSelected(row)"
                >
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>
                Investor

                <ng-container *ngIf="vehicleInvestmentRecipientsSelection.hasValue()">
                  ({{ vehicleInvestmentRecipientsSelection.selected.length }} selected)
                </ng-container>
              </th>
              <td mat-cell *matCellDef="let element">
                <div>
                  <strong class="clip-string-4">{{ element.name }}</strong>
                </div>
                <div class="clip-string-4" style="margin-top: 3px">{{ element.email }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="investmentAccount">
              <th mat-header-cell *matHeaderCellDef>Account</th>
              <td mat-cell *matCellDef="let element">
                <strong class="clip-string-5">{{ element.investment_account_legal_name }}</strong>
                <div>
                  {{ element.investment_account_type }}
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="totalDue">
              <th mat-header-cell *matHeaderCellDef>Allocation</th>
              <td mat-cell *matCellDef="let element">
                {{ element.total_due_formatted }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [class.selected]="isRowSelected(row)"
              (click)="vehicleInvestmentRecipientsSelection.toggle(row)"
            ></tr>
          </table>
        </div>

        <ng-container *ngIf="counterSignerRoles.length > 0">
          <h1 style="margin-top: 60px">Counter Signing Parties</h1>
          <div class="flex-container" style="margin-bottom: 40px">
            <ng-container *ngFor="let role of counterSignerRoles; let i = index">
              <div class="flex-cell-1" *ngIf="counterEligibleOrgMembers.length > 0">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Counter Signer {{ i + 1 }}</mat-label>
                  <mat-select
                    floatPlaceholder="always"
                    [(ngModel)]="counterSigners[counterSignersKey(i)]"
                    [required]="true"
                    [disabled]="counterSignerDisabled(i)"
                    name="counterSigner"
                  >
                    <mat-option
                      *ngFor="let member of counterEligibleOrgMembers"
                      [value]="member"
                      [disabled]="checkIfMemberSelected(member)"
                      >{{ member.full_name }} ({{ member.email }})</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <ng-template #elseNoVehicleRecipients>
          <p>This vehicle does not have any investments with assigned investment accounts</p>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="scope === SCOPE_ORGANIZATION">
        <h1>Add Recipients</h1>

        <fl-input-grid-legacy #organizationRecipientsInputGrid [rowData]="organizationRecipients"></fl-input-grid-legacy>

        <ng-container *ngIf="counterSignerRoles.length > 0">
          <h1 style="margin-top: 60px">Counter Signing Parties</h1>
          <div class="flex-container" style="margin-bottom: 40px">
            <ng-container *ngFor="let role of counterSignerRoles; let i = index">
              <div class="flex-cell-1" *ngIf="counterEligibleOrgMembers.length > 0">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Counter Signer {{ i + 1 }}</mat-label>
                  <mat-select
                    floatPlaceholder="always"
                    [(ngModel)]="counterSigners[counterSignersKey(i)]"
                    [required]="true"
                    [disabled]="counterSignerDisabled(i)"
                    name="counterSigner"
                  >
                    <mat-option
                      *ngFor="let member of counterEligibleOrgMembers"
                      [value]="member"
                      [disabled]="checkIfMemberSelected(member)"
                      >{{ member.full_name }} ({{ member.email }})</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="fl-stepper-footer flex-container">
      <button class="back" type="button" (click)="stepperNavigateBack()">Back</button>

      <button class="next" type="button" [disabled]="!hasValidRecipients()" (click)="stepperNavigateNext()" >
        Next
      </button>
    </div>
  </fl-stepper-section>

  <!-- STEP 4: Review & Share -->
  <fl-stepper-section label="Review & Send" [validationMethod]="hasValidDocsAndValidRecipients.bind(this)">
    <!-- Forms -->
    <!-- <div class="fl-stepper-subsection">
      <div>
        <h1>
          {{ formsToShare.length == 1 ? formsToShare.length + ' Form' : formsToShare.length + ' Forms'}}
        </h1>
      </div>

      <div class="table">
        <table class="dataset">
          <thead>
            <tr>
              <th colspan="2">Form</th>
            </tr>
          </thead>
          <tbody *ngIf="formsToShare.length > 0">
            <tr *ngFor="let form of formsToShare">
              <td class="column-thumbnail">
                <ng-container *ngIf="form.document; else elseNoDocument">
                  <img [src]="form.document.thumbnail" class="thumbnail" *ngIf="form.document.thumbnail" />
                </ng-container>
                <ng-template #elseNoDocument>
                  <div class="thumbnail">
                    <i class="material-icons">ballot</i>
                  </div>
                </ng-template>
              </td>
              <td>
                <a class="clip-string-2" title="{{form.title}}" target="_blank" [routerLink]="['/form', form.id]">
                  <strong>{{form.title}}</strong>
                </a>

                <div style="margin-top:3px;">
                  <ng-container *ngIf="form.display_type == 'single'">
                    Single page form
                  </ng-container>

                  <ng-container *ngIf="form.display_type == 'tabbed'">
                    Tabbed form
                  </ng-container>

                  <ng-container *ngIf="form.display_type == 'wizard'">
                    Multipage wizard
                  </ng-container>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->

    <!-- Recipients -->
    <ng-container *ngIf="scope === SCOPE_ORGANIZATION">
      <div class="fl-stepper-subsection">
        <h1>Recipients</h1>
        <div class="table" style="max-height: 50vh">
          <table class="dataset">
            <thead>
              <tr>
                <th>Recipient</th>

                <th>Email</th>
                <th>Forms</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let investor of organizationRecipientsTrimmed">
                <td>
                  {{ investor.name }}
                </td>
                <td>
                  {{ investor.email }}
                </td>
                <td>{{ formsToShare.length }} {{ formsToShare.length === 1 ? 'Form' : 'Forms' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="scope === SCOPE_VEHICLE">
      <div class="fl-stepper-subsection">
        <h1>Recipients</h1>
        <div class="table" style="max-height: 50vh">
          <table class="dataset">
            <thead>
              <tr>
                <th>Investor</th>

                <th>Account</th>

                <th>Forms</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let investor of vehicleInvestmentRecipientsSelection.selected">
                <td>
                  <strong>{{ investor.name }}</strong>
                  <div>
                    {{ investor.email }}
                  </div>
                </td>

                <td>
                  <strong class="clip-string-5">{{ investor.investment_account_legal_name }}</strong>
                  <div>
                    {{ investor.investment_account_type }}
                  </div>
                </td>

                <td>{{ formsToShare.length }} {{ formsToShare.length === 1 ? 'Form' : 'Forms' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <!-- Optional Message -->
    <div class="fl-stepper-subsection">
      <h2>Message Recipients?</h2>
      <div style="margin: -10px 0 15px">
        <mat-slide-toggle [(ngModel)]="sendEmail"
          >Toggle to include an optional message to all recipients above.</mat-slide-toggle
        >
      </div>

      <ng-container *ngIf="sendEmail">
        <mat-form-field appearance="fill" shouldLabelFloat="always" style="width: 100%">
          <mat-label>Subject Line</mat-label>
          <input matInput [(ngModel)]="emailSubject" name="email_subject" />
        </mat-form-field>

        <div style="margin-top: -1.34375em">
          <fl-froala-editor
            id="froala-editor"
            [froalaEditor]="froalaHelper.shareWizardContent"
            [(froalaModel)]="emailMessage"
          >
          </fl-froala-editor>
        </div>
      </ng-container>
    </div>

    <div class="fl-stepper-footer flex-container">
      <button class="back" type="button" (click)="stepperNavigateBack()">Back</button>
      <button
        class="submit"
        [disabled]="!hasValidDocsAndValidRecipients() || disabledSubmitButton"
        (click)="submit()"
      >
        Submit
      </button>
    </div>
  </fl-stepper-section>
</fl-stepper>

<div class="confirmation-screen" *ngIf="requestService.success">
  <h1>Requests Sent Successfully</h1>
  <p>Below is a list of each recipient's unique url</p>

  <div class="table">
    <table class="dataset">
      <tbody>
        <tr *ngFor="let recipient of sentRecipients">
          <td>
            <strong>{{ recipient.invitation_name }}</strong>
            <div>
              {{ recipient.invitation_email }}
            </div>
          </td>
          <td>
            <ng-container *ngIf="scope === SCOPE_VEHICLE">
              {{ environment.docsUrl }}/invitation/{{ recipient.investment_invitation_token }}
            </ng-container>
            <ng-container *ngIf="scope === SCOPE_ORGANIZATION">
              {{ environment.docsUrl }}/invitation/{{ recipient.invitation_token }}
            </ng-container>

            <a *ngIf="isAdmin$ | async" href="{{ environment.apiUrl }}/admin/signature_requests/{{ recipient.id }}" target="_blank">View In Active Admin</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
